import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {InputTextarea} from "primereact/inputtextarea";
import {classNames} from "primereact/utils";
import "./TextAreaInput.scss";
import {RequestType} from "../../models/Request";

export interface TextAreaInputProps {
    id: string;
    value: string;
    onValueChange: (proerty: string, value: string) => void;
    labelText: string;
    rows?: number;
    cols?: number;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    colorType?: string;
};

export const TextAreaInput = (p: TextAreaInputProps) => {
    const {
        id,
        value,
        onValueChange,
        labelText,
        rows,
        cols,
        placeholderText,
        control,
        setValue,
        errors,
        rules,
        disabled,
        colorType
    } = p;

    useEffect(() => {
        if (setValue) setValue(labelText, value)
    }, [value]);

    return (
        <div className="text-area-input">
            <label
                className={classNames("text-area-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <InputTextarea
                        {...field}
                        id={id}
                        rows={rows}
                        cols={cols}
                        value={value}
                        onChange={(e)=>{
                            field.onChange(e);
                            onValueChange(id, e.target.value)}}
                        className={classNames(
                            'textarea-input-field',
                            { 'textarea-input-field-request-import': colorType === RequestType.Import },
                            { 'textarea-input-field-request-export': colorType === RequestType.Export },
                            { 'textarea-input-field-request-relocation': colorType === RequestType.Relocation },
                            { 'p-invalid': fieldState.invalid }
                        )}
                        placeholder={placeholderText}
                        disabled={disabled}
                        />
                    )}
            />
        </div>
    );
};
